import React, { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useFormat } from 'helpers/hooks/useFormat';
import { useCart } from 'frontastic';
import CartItemsList from './cart-items-list';
import EmptyCart from './empty-cart';
import { CartContentProps } from '../types';

const CartContent: FC<CartContentProps> = ({
  className,
  isLoading,
  cartItems,
  isStockChecked,
  errorId,
  productLogo,
  ...props
}) => {
  const { formatMessage: formatCartMessage } = useFormat({ name: 'cart' });

  const { isEmpty, totalItems } = useCart();

  return (
    <div className={className}>
      <div className="flex items-center justify-between">
        {!cartItems && isLoading ? (
          <div className="relative mb-10 h-full w-full">
            <div className="relative mb-10 h-[32px] w-full md:w-[25%]">
              <Skeleton className="h-full"></Skeleton>
            </div>
            <div className="mt-16 flex gap-5">
              <div className="relative mb-10 h-[24px] w-[30%]">
                <Skeleton />
              </div>
              <div className="relative mb-10 h-[24px] w-[10%]">
                <Skeleton />
              </div>
            </div>
          </div>
        ) : (
          <h1 className="m-0 text-[23px] font-bold uppercase leading-[25px] md:w-full md:text-[34px] md:leading-[40px] lg:text-[28px]  xl:text-[34px]">
            {formatCartMessage({ id: 'cart.shopping', defaultMessage: 'Shopping Cart' })}
            {!isEmpty && ': '}
            {!isEmpty && (
              <span className="text-secondary-black">
                ({totalItems} {formatCartMessage({ id: 'items', defaultMessage: 'Items' })})
              </span>
            )}
          </h1>
        )}
      </div>

      {!cartItems && isLoading ? (
        <>
          <div className="border-y border-neutral-400 py-24">
            <div className="relative mb-10 h-full w-full">
              <div className="relative mb-10 h-[24px] w-full md:w-[30%]">
                <Skeleton className="h-full"></Skeleton>
              </div>
              <div className="relative mb-10 h-[16px] w-full">
                <Skeleton />
              </div>
            </div>
          </div>
          <div className="mt-32 flex w-full gap-[100px]">
            <div className="relative mb-10 h-[24px] w-full md:w-[50px]">
              <Skeleton className="h-full"></Skeleton>
            </div>
            <div className="relative mb-10 h-[24px] w-full md:w-[150px]">
              <Skeleton className="h-full"></Skeleton>
            </div>
          </div>
        </>
      ) : (
        <>
          {!isEmpty ? (
            <CartItemsList
              cartItems={cartItems}
              isStockChecked={isStockChecked}
              errorId={errorId}
              productLogo={productLogo}
              {...props}
            />
          ) : (
            <EmptyCart {...props} />
          )}
        </>
      )}
    </div>
  );
};

export default CartContent;
